var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.21 62.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2",
    "data-name": "Lager 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.2,9.25H21.31V50.41H9.92V9.25H0V0H36.2Z"
  }), /*#__PURE__*/React.createElement("text", null), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.15,62.41V12H35.7q8.43,0,13,3.09a10,10,0,0,1,4.54,8.72A10.33,10.33,0,0,1,50.45,31,14.44,14.44,0,0,1,43.4,35.2v.14a14,14,0,0,1,8.59,4,11.07,11.07,0,0,1,3.22,8,13.43,13.43,0,0,1-5,11q-4.95,4.07-13.53,4.06Zm11.36-42v12H33.69a8.36,8.36,0,0,0,5.54-1.7,5.82,5.82,0,0,0,2-4.7q0-5.55-8.29-5.55Zm0,20.39V54.05h0c2.58-.41,3-.61,4.51-1.83a6.1,6.1,0,0,0,2.24-5,5.72,5.72,0,0,0-2.2-4.75c-1.47-1.15-1.94-1.33-4.55-1.72Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0bebc27a7add2c61d8ccb39e9c80f9f3.svg";
export { ForwardRef as ReactComponent };